import { render, staticRenderFns } from "./uploadResult.vue?vue&type=template&id=14bbe952"
import script from "./uploadResult.vue?vue&type=script&lang=js"
export * from "./uploadResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports